
export interface IGroupBilling {
    id: number,

    groupingPurpose: string,
    reference: string,
    issueDate: Date,

    shippingCountryCode: string,
    shippingState: string,
    shippingPostalCode: string,
    shippingCity: string,
    shippingAddressLine1: string,
    shippingAddressLine2: string,
    shippingName: string,

    aliasUserWhoCreated: string,
    aliasUserWhoModified: string,
    personNameUserWhoCreated: string,
    personNameUserWhoModified: string, 

    amount: number,
    amountValidated: number,
    amountUnvalidated: number,
    amountCancelled: number,

    amountPaid: number,
    unpaidAmount: number,

    groupBillingBillings: IGroupBillingBilling[]
}


export interface IGroupBillingBilling {
    id: number,

    groupBillingId: number,
    billingId: number,

    customerName: string,
    showroomName: string,
    currencyCode: string,

    status: string,
    billingNumber: string,

    aliasUserWhoCreated: string,
    aliasUserWhoModified: string,
    personNameUserWhoCreated: string,
    personNameUserWhoModified: string,    

    netAmount: number,
    amount: number,
    amountPaid: number,
    unpaidAmount: number,

    groupBillingReference: string
}


export const defaultGroupBilling : IGroupBilling = {
    id: 0,

    groupingPurpose: '',
    reference: '',
    issueDate: new Date(),

    
    shippingCountryCode: '',
    shippingState: '',
    shippingPostalCode: '',
    shippingCity: '',
    shippingAddressLine1: '',
    shippingAddressLine2: '',
    shippingName: '',

    aliasUserWhoCreated: '',
    aliasUserWhoModified: '',
    personNameUserWhoCreated: '',
    personNameUserWhoModified: '', 

    amount: 0,
    amountValidated: 0,
    amountUnvalidated: 0,
    amountCancelled: 0,

    amountPaid: 0,
    unpaidAmount: 0,

    groupBillingBillings: []
}


export interface IDashboardGroupBilling {
    //operationsByCategory: {schoolYearName: string, category: string, amount: number} [],
    operationsByMode: {mode: string, netAmount: number, cancelledAmount: number}[]
  }
  

  export interface IGroupBillingSearch {
    groupingPurpose: string,
    reference: string,

    startDate: Date,
    endDate: Date,

  }


